<template>
  <div
    class="ws-callout"
    :style="[{'background-color':backgroundColor}]"
  >
    <div class="ws-callout_left-section">
      <v-icon v-if="icon.type" :color="icon.color">{{icon.type}}</v-icon>
      <div>
        <p
          v-if="title"
          :style="[{'color':title.color}]"
          class="ws-callout_left-section_title"
        >
          {{title.text}}
        </p>
        <p
          v-if="remark"
          class="ws-callout_left-section_remark"
          :style="[{'color':remark.color}]"
        >
          {{remark.text}}
        </p>
      </div>
    </div>
    <div v-if="btns && btns.length > 0" class="ws-button-group">
      <WsBtn
        v-for="(btn,btnKey) in btns"
        :key="btnKey"
        :to="`${btn.to? btn.to: ''}`"
        :color="btn.color"
        :outlined="btn.outlined"
        @click="$_onCalloutClick(btn)"
      >
        {{btn.text}}
      </WsBtn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Object,
    },
    title: {
      type: Object,
    },
    remark: {
      type: Object,
    },
    btns: {
      type: Array,
    },
    backgroundColor: {
      type: String,
    }
  },
  methods:{
    $_onCalloutClick(btn){
      if (btn.emit) {
        this.$emit('call-out-click', btn)
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-callout.scss";
</style>